import i18next from "../i18n";

export const techDataActiveSections = {
  COOLING_SYSTEM: "cooling_systems",
  ENERGY_MIX: "energyMix",
  FLOOR: "floors",
  HEATING_SYSTEM: "heating_systems",
  HOT_WATER: "hot_water",
  INFILTRATION: "infiltrations",
  PV_SYSTEM: "pv_panel",
  ROOFTOP: "rooftops",
  WALL: "facades",
  WINDOWS: "windows",
};

export const techDataNewSections = {
  ROOM: "room",
  // VENTILATION: "ventilation",
};

export const techDataInactiveSections = {
  BUILDING_AUTOMATION: "buildingAutomation",
  SHADING_SYSTEM: "shadingSystem",
};

export const techDataSections = {
  ...techDataActiveSections,
  ...techDataNewSections,
  ...techDataInactiveSections,
};

export const techDataColsAPINames = {
  AREA: "area",
  AREA_COVERED: "areaCovered",
  CAPACITY_PANEL: "capacityPanel",
  CO2_EMISSIONS_PER_KWH: "co2_emissions_per_kwh",
  COLOR: "color",
  COP: "cop",
  COST_INCREASE_PER_YEAR: "cost_increase_per_year",
  COST_PER_KWH: "cost_per_kwh",
  DC_AC_INVERTER_CONFIGURATION: "dcacInverterConfig",
  DECENTRAL_TYPE: "decentralType",
  DESCRIPTION: "description",
  DISTRIBUTION_LOSSES: "distributionLosses",
  ENERGY_SOURCE: "energySource",
  G_VALUE: "g_value",
  HEATING_SYSTEM: "heatingSystem",
  INFILTRATION: "infiltration",
  INSTALLED: "installed",
  LAST_CHECKED: "last_checked",
  MANUFACTURER_NAME: "manufacturerName",
  MODERNIZATION: "modernization",
  MONITORING_INSTALLED: "monitoringInstalled",
  NUMBER_OF_WINDOWS: "number_of_windows",
  PEAK_THERMAL_POWER: "peakThermalPower",
  STORAGE_LOSSES: "storageLosses",
  STORAGE_TEMPERATURE: "storageTemperature",
  STORAGE_VOLUME: "storageVolume",
  SYSTEM_NAME: "systemName",
  SYSTEM_TYPE: "systemType",
  THICKNESS: "thickness",
  U_VALUE: "u_value",
  UTILITY_MIX: "utility_mix",
  WINDOW_TYPE: "window_type",
};

const dataGroupLabelsOrder = ["buildingEnvelope", "roomConfiguration", "energySupplySystem", "other"];

export const dataLabels = {
  [dataGroupLabelsOrder[0]]: [
    {
      dataKey: techDataSections.WINDOWS,
      keyInI18n: "windows",
      order: 1,
    },
    {
      dataKey: techDataSections.WALL,
      keyInI18n: "wall",
      order: 2,
    },
    {
      dataKey: techDataSections.FLOOR,
      keyInI18n: "floor",
      order: 3,
    },
    {
      dataKey: techDataSections.ROOFTOP,
      keyInI18n: "rooftop",
      order: 4,
    },
    {
      dataKey: techDataSections.INFILTRATION,
      keyInI18n: "infiltration",
      order: 5,
    },
    {
      dataKey: techDataSections.SHADING_SYSTEM,
      keyInI18n: "shadingSystem",
      order: 6,
    },
  ],
  [dataGroupLabelsOrder[1]]: [
    {
      dataKey: techDataSections.ROOM,
      keyInI18n: "room",
      order: 6,
    },
  ],
  [dataGroupLabelsOrder[2]]: [
    {
      dataKey: techDataSections.ENERGY_MIX,
      keyInI18n: "energyMix",
      order: 7,
    },
    {
      dataKey: techDataSections.HEATING_SYSTEM,
      keyInI18n: "heatingSystem",
      order: 8,
    },
    {
      dataKey: techDataSections.HOT_WATER,
      keyInI18n: "hotWater",
      order: 9,
    },
    {
      dataKey: techDataSections.COOLING_SYSTEM,
      keyInI18n: "coolingSystem",
      order: 10,
    },
    {
      dataKey: techDataSections.PV_SYSTEM,
      keyInI18n: "pvSystem",
      order: 11,
    },
  ],
  [dataGroupLabelsOrder[3]]: [
    {
      dataKey: techDataSections.BUILDING_AUTOMATION,
      keyInI18n: "buildingAutomation",
      order: 12,
    },
    // {
    //   dataKey: techDataSections.VENTILATION,
    //   keyInI18n: "ventilation",
    //   order: 13,
    // },
  ],
};

export const techDataLabelsOrder = Object.keys(dataLabels).reduce((acc, key) => {
  acc = [...acc, ...dataLabels[key].map((label) => label.dataKey)];
  return acc;
}, []);

export const getTechnicalDataColumnsDisplayNamesEnums = (key) => {
  return i18next.t(`TechnicalData.table.columns.${key}`);
};

const getTechnicalDataSectionI18nKey = (sectionKey) => {
  let activeTabI18nKey = null;
  Object.keys(dataLabels).forEach((groupLabel) => {
    dataLabels[groupLabel].forEach((label) => {
      if (label.dataKey === sectionKey) {
        activeTabI18nKey = label.keyInI18n;
        return;
      }
    });
  });
  return activeTabI18nKey;
};

export const getTechnicalDataSectionDisplayName = (sectionKey) => {
  const activeTabI18nKey = getTechnicalDataSectionI18nKey(sectionKey);
  return i18next.t(`TechnicalData.nav.${activeTabI18nKey}`);
};

export const getTechnicalDataSectionFilesDownloadDisplayName = (sectionKey) => {
  const activeTabI18nKey = getTechnicalDataSectionI18nKey(sectionKey);
  return i18next.t(`TechnicalData.nav.${activeTabI18nKey}FilesDownload`);
};
